import { useI18n } from "vue-i18n";

class PersonService {

    static formatName(lastname: string, firstname: string): string {
        return this.formatHonorificAndName(null, lastname, firstname);
    }

    static formatHonorificAndName(honorific: string, lastname: string, firstname: string): string {
        const validLastName = lastname ?? '';
        const validFirstName = firstname ?? '';
        let validHonorific = '';
        if (honorific) {
            const { t, te } = useI18n();
            const key = `common.honorifics.${honorific}`;
            validHonorific = te(key) ? t(key) : honorific;
        }

        return [validHonorific, validLastName.toUpperCase(), validFirstName].filter(Boolean).join(' ');
    }
}

export default PersonService;